import { Promocode } from '@web/store/interfaces';
import { promocodeStorage } from './promocode-storage';

export const getDefaultPromocode = ({ code, usage }: Promocode): Promocode => {
  const sessionPromocode = promocodeStorage.get();
  return {
    code: code ?? (sessionPromocode ? sessionPromocode[usage] : null),
    usage,
  };
};
